export class Constants {
  static readonly ONE_MIN = 60

  static readonly ONE_HOUR = 60 * 60

  static readonly ONE_DAY = 60 * 60 * 24

  static readonly ONE_YEAR = Constants.ONE_DAY * 365
}
